import { render } from "./CoordinatedRedsysAccount.vue?vue&type=template&id=19aa2812&scoped=true"
import script from "./CoordinatedRedsysAccount.vue?vue&type=script&lang=js"
export * from "./CoordinatedRedsysAccount.vue?vue&type=script&lang=js"

import "./CoordinatedRedsysAccount.vue?vue&type=style&index=0&id=19aa2812&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-19aa2812"]])

export default __exports__